function formatDate(value) {
  const raw = String(value || '').trim();
  if (!raw) return '-';
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return raw;
  return date.toLocaleString();
}

export function buildCommissionPlansTableModel(dtoRows) {
  return dtoRows.map((row) => ({
    key: row.key, uid: row.uid, name: row.name, maxDepth: row.maxDepth,
    isDefault: row.isDefault, isActive: row.isActive, tierCount: row.tierCount,
    createdAt: formatDate(row.created),
  }));
}
